import * as React from 'react';
import * as PropTypes from 'prop-types';

function TaxIncludedHint(props) {
  if (!props.hint) {
    return null;
  }

  return (<span>{props.hint}</span>);
}

TaxIncludedHint.propTypes = {
  hint: PropTypes.string,
};

TaxIncludedHint.defaultProps = {
  hint: '',
};

export default TaxIncludedHint;



// WEBPACK FOOTER //
// ./javascripts/components/shared/tax_included_hint.jsx